import { render, staticRenderFns } from "./Headset.vue?vue&type=template&id=03427a52&"
import script from "./Headset.vue?vue&type=script&lang=js&"
export * from "./Headset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports